/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryDiseasesListAliases {
  BUTTON_ADD_HEALTH_HISTORY_DISEASES = 'button-add-health-history-diseases',
  CONTEXTUAL_BAR_HEALTH_HISTORY_DISEASES = 'contextual-bar-health-history-diseases',
  DECK_HEALTH_HISTORY_DISEASES = 'deck-health-history-diseases',
  FETCH_HEALTH_HISTORY_DISEASES = 'fetch-health-history-diseases',
  FILTERED_LIST_HEALTH_HISTORY_DISEASES = 'filtered-list-health-history-diseases',
  GLOBAL_ACTIONS_HEALTH_HISTORY_DISEASES = 'global-actions-health-history-diseases',
  HEALTH_HISTORY_CARD_DISEASES = 'health-history-card-diseases',
  LAYOUT_HEALTH_HISTORY_DISEASES_LIST = 'layout-health-history-diseases-list',
  LEGENDS_HEALTH_HISTORY_DISEASES = 'legends-health-history-diseases',
  PANEL_HEALTH_HISTORY_DISEASES = 'panel-health-history-diseases',
}
export { HealthHistoryDiseasesListAliases };
